var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/rrTray.j2"] = require( "macros/rrTray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/account-recommendations.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/rrTray.j2", false, "account/templates/partials/account-recommendations.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("richRelevanceTray")) {
var t_4 = t_1.richRelevanceTray;
} else {
cb(new Error("cannot import 'richRelevanceTray'")); return;
}
context.setVariable("richRelevanceTray", t_4);
output += "<div class=\"dom-account-recommendations o-column o-extra-small--12 o-medium--9 o-medium--offset-3 o-large--10 o-large--offset-2 c-account-recommendations js-account-recommendations\">\n\n    ";
var t_5;
t_5 = (lineno = 4, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.account"]));
frame.set("rrRecs", t_5, true);
if(frame.topLevel) {
context.setVariable("rrRecs", t_5);
}
if(frame.topLevel) {
context.addExport("rrRecs", t_5);
}
output += "\n\n    ";
output += runtime.suppressValue((lineno = 6, colno = 22, runtime.callWrap(t_4, "richRelevanceTray", context, [runtime.contextOrFrameLookup(context, frame, "None"),runtime.contextOrFrameLookup(context, frame, "rrRecs"),true])), env.opts.autoescape);
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/account-recommendations.j2"] , dependencies)